module.exports = __webpack_public_path__ + "media/assets/images/profit-loss-bar-236e9b3d1c177a71d5df6e109c46b819.svg";